"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinnerWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const SpinnerWrapper = exports.SpinnerWrapper = _styledComponents.default.img.withConfig({
  displayName: "Spinnerstyle__SpinnerWrapper",
  componentId: "sc-1ax3ggd-0"
})(["margin:10px auto;width:25px;height:25px;display:block;animation:spinner 2s infinite linear;@keyframes spinner{100%{transform:rotate(360deg);}}}"]);